import React from 'react';
import { authorityStats, authoritySource } from '../data/tables';
export function AuthorityBar() {
  return <section aria-labelledby="authority-heading" className="bg-ink" data-id="element-21" data-mp="3bai7bspluha6">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-22" data-mp="3p2q1rdtf1w5p">
        <h2 id="authority-heading" className="sr-only" data-id="element-23" data-mp="3p52ijnnfu0h6">
          The state of small child care in the US
        </h2>

        <ul className="grid grid-cols-2 gap-x-8 gap-y-10 md:grid-cols-4" data-id="element-24" data-mp="2xbihwiu9pycy">
          {authorityStats.map(stat => <li key={stat.label} data-id="element-25" data-mp="2sdgzm04o232j">
              <p className="font-mono text-[34px] font-medium leading-none text-brass md:text-[44px]" data-id="element-26" data-mp="2se9ykexdvoa4">
                {stat.value}
              </p>
              <p className="mt-3 max-w-[15rem] text-[14px] leading-[1.5] text-paper/60" data-id="element-27" data-mp="31dn817liccuu">
                {stat.label}
              </p>
            </li>)}
        </ul>

        <p className="mt-12 font-mono text-[10px] uppercase tracking-label text-paper/35" data-id="element-28" data-mp="lo2fx2cb2i0t">
          {authoritySource}
        </p>
      </div>
    </section>;
}